import { IconSearch } from "@tabler/icons-react";
import { Card, Group, Heading, Input, Stack, Switch } from "@/components/ui";

/**
 * Bar de filtros · texto libre + switch solo activos. Los filtros se aplican
 * en el SERVIDOR · el contador "Mostrando X–Y de Z" vive junto a la paginación.
 */
export function ProveedoresFiltros({
  texto,
  onTextoChange,
  soloActivos,
  onSoloActivosChange,
}: {
  texto: string;
  onTextoChange: (t: string) => void;
  soloActivos: boolean;
  onSoloActivosChange: (v: boolean) => void;
}) {
  return (
    <Card padding="lg">
      <Stack gap="md">
        <Heading order={5}>Filtros</Heading>
        <Group align="flex-end" gap="md" wrap="wrap">
          <Input
            label="Buscar"
            placeholder="número, RFC, razón social…"
            leftSection={<IconSearch size={14} stroke={1.7} />}
            value={texto}
            onChange={(e) => onTextoChange(e.currentTarget.value)}
            wrapperClassName="min-w-70 flex-1"
          />
          <Switch checked={soloActivos} onCheckedChange={onSoloActivosChange} label="Solo activos" />
        </Group>
      </Stack>
    </Card>
  );
}
